<template>
  <div id="boton-preguntas">
    <v-container grid-list-xl fluid>
      <v-flex lg12>
        <v-card>
          <boton-proceso-tab-preguntas
            :lstBtn="lstBtn"
          ></boton-proceso-tab-preguntas>
        </v-card>
        <div v-if="loading">
          <loading></loading>
        </div>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import Material from "vuetify/es5/util/colors";
import BotonProcesoTabPreguntas from "@/modules/configuration/commonsviews/BotonProcesoTabPreguntas.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "botones-preguntas",

  components: {
    MiniStatistic,
    BotonProcesoTabPreguntas,
    Loading,
  },
  data: () => ({
    color: Material,
    lstBtn: [],
    lstBtnCompleta: [
      {
        icon: "fa-check-circle",
        title: "Correcciones",
        subtitle: "",
        color: "teal darken-3",
        class: "aplicacion rombo elevation-10", //color (img rombo): 'teal' se relaciona con class (borde rombo) 'aplicacion'
        subPro: "CORRECCIONES", //valor para subproceso en BotonProcesoTabPreguntas.vue
        tab: "Correcciones", //valor para tab en BotonProcesoTabPreguntas.vue
      },
      {
        icon: "business",
        title: "Administrativo",
        subtitle: "",
        color: "blue darken-3",
        class: "administrativo rombo elevation-10",
        subPro: "ADMINISTRATIVO",
        tab: "Administrativo",
      },
      {
        icon: "all_inbox",
        title: "Prod&Report",
        subtitle: "",
        color: "yellow darken-3",
        class: "prod rombo elevation-10",
        subPro: "REPORTES",
        tab: "Productos",
      },
    ],
  }),
  computed: {},
  Mounted() {},
  created() {
    this.loadDataPanelControl();
  },
  methods: {
    async loadDataPanelControl() {
      this.loading = true;
      let lstBtnTmp = await this.loadPanelControl();
      for (let i = 0; i < lstBtnTmp.length; i++) {
        this.lstBtn.push(this.lstBtnCompleta[lstBtnTmp[i] - 1]);
      }
      // console.log("st::lstBtnCompleta:" + JSON.stringify(this.lstBtnCompleta, null, 2));
      this.loading = false;
    },
    async loadPanelControl() {
      return await axios
        .get(
          "/panelControl/posicionActivos/" + this.$store.getters.contratoStored
        )
        .then(function (response) {
          // console.log('response  orden mostrar preguntas:' + response.data);
          return response.data;
        })
        .catch(function (error) {
          console.log("error loadPanelControl:" + error);
        });
    },
  },
};
</script>
